import { useState } from "react";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="bg-white shadow-md">
            <div className="max-w-7xl mx-auto px-4">
                <div className="flex justify-between items-center h-16">

                    {/* Logo */}
                    <div className="text-xl font-bold text-blue-600">
                        <img
                            src="/polagoniLogo.png"
                            alt="Polagoni Logo"
                            className="h-[90px] w-auto object-contain"
                        />

                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex space-x-6">
                        <a href="/" className="text-gray-700 hover:text-blue-600">
                            Home
                        </a>
                        <a href="/about" className="text-gray-700 hover:text-blue-600">
                            About
                        </a>
                        <a href="/services" className="text-gray-700 hover:text-blue-600">
                            Services
                        </a>
                        <a href="/contact" className="text-gray-700 hover:text-blue-600">
                            Contact
                        </a>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        className="md:hidden focus:outline-none"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <svg
                            className="w-6 h-6 text-gray-700"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d={
                                    isOpen
                                        ? "M6 18L18 6M6 6l12 12"
                                        : "M4 6h16M4 12h16M4 18h16"
                                }
                            />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="md:hidden bg-white px-4 pb-4">
                    <a href="/" className="block py-2 text-gray-700">
                        Home
                    </a>
                    <a href="/about" className="block py-2 text-gray-700">
                        About
                    </a>
                    <a href="/services" className="block py-2 text-gray-700">
                        Services
                    </a>
                    <a href="/contact" className="block py-2 text-gray-700">
                        Contact
                    </a>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
